import { Icon, Tooltip } from "@smart/itops-sb-design-system-dom";

import { DuplicateContactWarning } from "./duplicate-helpers";

export const duplicateWarningTestId = "contact-details-duplicate-warning";

export const DuplicateWarningLine = ({
  boldText,
  suffix,
  tooltipText,
}: DuplicateContactWarning) => {
  const bold = <span className="font-semibold">{boldText}</span>;

  return (
    <div
      className="flex items-center gap-[0.4rem] min-w-0 text-caption text-neutral-400"
      data-testid={duplicateWarningTestId}
    >
      <Icon
        name="solidTriangleExclamation"
        className="shrink-0 text-yellow-450"
      />
      {tooltipText ? (
        <Tooltip
          text={tooltipText}
          className="shrink-0"
          placement="bottom"
          offsetBy={5}
        >
          {bold}
        </Tooltip>
      ) : (
        bold
      )}
      <span className="truncate">{suffix}</span>
    </div>
  );
};
